import { StandardEvents } from '@shopify/events';

/**
 * Holds the link for a variant sold on another site (its [External] Link metafield).
 * When the shopper picks another variant, it swaps in that variant's link, or hides itself
 * and brings back the cart form if the new variant is sold here.
 */
class ExternalPurchase extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  /** @param {Event & { promise?: Promise<any> }} event */
  #onProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        const html = detail?.html;
        if (!html) return;

        const next = html.querySelector(`external-purchase[data-block-id="${this.dataset.blockId}"]`);
        if (!next) return;

        const active = next.hasAttribute('data-active');
        this.innerHTML = next.innerHTML;
        this.toggleAttribute('data-active', active);
        this.closest('.buy-buttons-block')?.classList.toggle('buy-buttons-block--external', active);
      })
      .catch(() => {});
  };
}

if (!customElements.get('external-purchase')) customElements.define('external-purchase', ExternalPurchase);
